(function () {
  // Shopify exposes variant prices in cents; $0.01 is the quote-request sentinel.
  var QUOTE_REQUEST_PRICE_CENTS = 1;

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function parseJson(script) {
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('Unable to parse quote request product data', error);
      return null;
    }
  }

  function findVariant(product, variantId) {
    if (!product || !variantId) return null;

    return product.variants.find(function (variant) {
      return Number(variant.id) === Number(variantId);
    }) || null;
  }

  function setText(element, value) {
    if (element) {
      element.textContent = value || '';
    }
  }

  function setValue(element, value) {
    if (element) {
      element.value = value || '';
    }
  }

  function setFieldName(element, name) {
    if (!element) return;

    if (name) {
      element.setAttribute('name', name);
    } else {
      element.removeAttribute('name');
    }
  }

  function normalizeJotformId(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function withFallback(value, fallback) {
    var normalized = String(value || '');

    if (!normalized || normalized.toLowerCase().indexOf('translation missing') !== -1) {
      return fallback;
    }

    return normalized;
  }

  function normalizeLabels(labels) {
    var fallbackLabels = {
      button: 'Contact Store for Price',
      not_provided: 'Not provided',
      none: 'None',
      summary_intro: 'Quote request submitted from the product page.',
      product: 'Product',
      product_url: 'Product URL',
      variant: 'Variant',
      variant_id: 'Variant ID',
      sku: 'SKU',
      quantity: 'Quantity',
      thumbnail: 'Thumbnail',
      name: 'Name',
      email: 'Email',
      company: 'Company',
      phone: 'Phone',
      details: 'Additional details'
    };

    Object.keys(fallbackLabels).forEach(function (key) {
      labels[key] = withFallback(labels[key], fallbackLabels[key]);
    });

    return labels;
  }

  function queryAll(container, selector) {
    return Array.prototype.slice.call(container.querySelectorAll(selector));
  }

  function parseJsonAttribute(element, attribute) {
    if (!element || !element.getAttribute(attribute)) return null;

    try {
      return JSON.parse(element.getAttribute(attribute));
    } catch (error) {
      return null;
    }
  }

  function normalizeQuantity(value) {
    var quantity = parseInt(value, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function isQuoteRequestVariant(variant) {
    return !!variant && Number(variant.price) <= QUOTE_REQUEST_PRICE_CENTS;
  }

  function getGemPagesVariant(productRoot) {
    var context = parseJsonAttribute(productRoot, 'gp-context') || {};
    var data = parseJsonAttribute(productRoot, 'gp-data') || {};

    return context.variantSelected
      || context.variant
      || data.variantSelected
      || data.variant
      || null;
  }

  function syncGemPagesQuoteState(productRoot) {
    if (!productRoot) return;

    var isQuoteVariant = isQuoteRequestVariant(getGemPagesVariant(productRoot));

    productRoot.classList.toggle('product--quote-request-active', isQuoteVariant);

    queryAll(productRoot, 'gp-product-price, gp-product-button').forEach(function (element) {
      setElementHidden(element, isQuoteVariant);
    });
  }

  function initGemPagesQuoteGuard(productRoot) {
    if (!productRoot || productRoot.dataset.quoteRequestGpInitialized === 'true') return;

    productRoot.dataset.quoteRequestGpInitialized = 'true';
    syncGemPagesQuoteState(productRoot);

    var observer = new MutationObserver(function () {
      syncGemPagesQuoteState(productRoot);
    });

    observer.observe(productRoot, {
      attributes: true,
      attributeFilter: ['gp-context', 'gp-data'],
      childList: true,
      subtree: true
    });

    productRoot.addEventListener('change', function () {
      window.setTimeout(function () {
        syncGemPagesQuoteState(productRoot);
      }, 0);
    });

    productRoot.addEventListener('click', function () {
      window.setTimeout(function () {
        syncGemPagesQuoteState(productRoot);
      }, 150);
    });
  }

  function initGemPagesQuoteGuards(container) {
    var root = container || document;

    if (root.matches && root.matches('gp-product')) {
      initGemPagesQuoteGuard(root);
    }

    queryAll(root, 'gp-product').forEach(initGemPagesQuoteGuard);
  }

  function getFallbackQuoteVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;

    var quoteVariants = product.variants.filter(isQuoteRequestVariant);

    if (quoteVariants.length !== product.variants.length) return null;

    return quoteVariants.find(function (variant) {
      return variant.available;
    }) || quoteVariants[0] || null;
  }

  function setElementHidden(element, hidden) {
    if (!element) return;

    element.hidden = hidden;

    if (hidden) {
      element.setAttribute('aria-hidden', 'true');
    } else {
      element.removeAttribute('aria-hidden');
    }
  }

  function normalizeUrl(value) {
    var url = String(value || '').trim();

    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;

    try {
      var parsedUrl = new URL(url, window.location.origin);

      if (parsedUrl.protocol === 'http:') {
        parsedUrl.protocol = 'https:';
      }

      return parsedUrl.toString();
    } catch (error) {
      return url;
    }
  }

  function getFocusable(container) {
    return Array.prototype.slice.call(container.querySelectorAll([
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'textarea:not([disabled])',
      'select:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(','))).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  function initQuoteRequest(modal) {
    if (modal.dataset.quoteRequestInitialized === 'true') return;
    modal.dataset.quoteRequestInitialized = 'true';

    var form = modal.closest('[data-quote-request-form]');
    var root = modal.closest('[data-quote-request-product]')
      || document.querySelector('[data-quote-request-product]')
      || document.querySelector('gp-product')
      || document.querySelector('[data-product-wrapper]')
      || document.querySelector('main');
    var data = parseJson(modal.querySelector('[data-quote-request-product-json]'));

    if (!form || !root || !data || !data.product) return;

    form.noValidate = true;

    var product = data.product;
    var labels = normalizeLabels(data.labels || {});
    var jotform = data.jotform || {};
    var jotformFields = jotform.fields || {};
    var jotformFormId = normalizeJotformId(jotform.form_id);
    var state = {
      currentStep: 1,
      lastFocus: null,
      productUrl: data.product_url || window.location.href,
      submitTimeout: null,
      submitting: false,
      variant: null
    };

    var elements = {
      trigger: root.querySelector('[data-quote-request-trigger]'),
      productForm: root.querySelector('[data-product-form], form[data-type="add-to-cart-form"], form[action*="/cart/add"]'),
      variantSelection: root.querySelector('[data-variant-selection]'),
      variantInput: root.querySelector('[data-variants], input[name="id"], select[name="id"]'),
      quantityInput: root.querySelector('[data-quantity-input], input[name="product-quantity"], input[name="quantity"]'),
      dovrQuantityInput: root.querySelector('#dovr-quantity'),
      actionButtons: queryAll(root, '[data-product-atc], .product-form--atc-button:not(.product-form--quote-request-button), gp-product-button'),
      paymentButtons: queryAll(root, '.shopify-payment-button'),
      paymentTerms: queryAll(root, '[data-payment-terms-reference], [data-payment-terms-target], shopify-payment-terms'),
      financingMessages: queryAll(root, '.affirm-as-low-as, .dovr-affirm-messaging'),
      pricing: queryAll(root, '[data-product-pricing], gp-product-price'),
      quantityControls: queryAll(root, '[data-quantity-selector]'),
      dialog: modal.querySelector('[data-quote-request-dialog]'),
      stepsList: modal.querySelector('[data-quote-request-steps]'),
      steps: modal.querySelectorAll('[data-quote-request-step]'),
      progress: modal.querySelectorAll('[data-quote-request-progress]'),
      successMessage: modal.querySelector('[data-quote-request-success]'),
      errorMessage: modal.querySelector('[data-quote-request-error]'),
      iframe: form.querySelector('[data-quote-request-iframe]'),
      submitButton: modal.querySelector('[data-quote-request-submit]'),
      jotformFormId: form.querySelector('[data-quote-request-jotform-form-id]'),
      jotformSpc: form.querySelector('[data-quote-request-jotform-spc]'),
      quantity: modal.querySelector('[data-quote-request-quantity]'),
      image: modal.querySelector('[data-quote-request-image]'),
      imagePlaceholder: modal.querySelector('[data-quote-request-image-placeholder]'),
      reviewImage: modal.querySelector('[data-quote-request-review-image]'),
      reviewImagePlaceholder: modal.querySelector('[data-quote-request-review-image-placeholder]'),
      productTitle: modal.querySelector('[data-quote-request-product-title]'),
      variantTitle: modal.querySelector('[data-quote-request-variant]'),
      sku: modal.querySelector('[data-quote-request-sku]'),
      firstName: modal.querySelector('[data-quote-request-first-name]'),
      lastName: modal.querySelector('[data-quote-request-last-name]'),
      email: modal.querySelector('[data-quote-request-email]'),
      company: modal.querySelector('[data-quote-request-company]'),
      phone: modal.querySelector('[data-quote-request-phone]'),
      details: modal.querySelector('[data-quote-request-details]'),
      hiddenProduct: modal.querySelector('[data-quote-request-hidden-product]'),
      hiddenProductUrl: modal.querySelector('[data-quote-request-hidden-product-url]'),
      hiddenVariant: modal.querySelector('[data-quote-request-hidden-variant]'),
      hiddenVariantId: modal.querySelector('[data-quote-request-hidden-variant-id]'),
      hiddenSku: modal.querySelector('[data-quote-request-hidden-sku]'),
      hiddenQuantity: modal.querySelector('[data-quote-request-hidden-quantity]'),
      hiddenThumbnail: modal.querySelector('[data-quote-request-hidden-thumbnail]'),
      hiddenMessage: modal.querySelector('[data-quote-request-hidden-message]'),
      reviewProduct: modal.querySelector('[data-quote-request-review-product]'),
      reviewVariant: modal.querySelector('[data-quote-request-review-variant]'),
      reviewSku: modal.querySelector('[data-quote-request-review-sku]'),
      reviewQuantity: modal.querySelector('[data-quote-request-review-quantity]'),
      reviewName: modal.querySelector('[data-quote-request-review-name]'),
      reviewEmail: modal.querySelector('[data-quote-request-review-email]'),
      reviewCompany: modal.querySelector('[data-quote-request-review-company]'),
      reviewPhone: modal.querySelector('[data-quote-request-review-phone]'),
      reviewDetails: modal.querySelector('[data-quote-request-review-details]')
    };

    function ensureTrigger() {
      if (elements.trigger) {
        updateTriggerLabel();
        return;
      }

      var anchor = elements.actionButtons.length
        ? elements.actionButtons[elements.actionButtons.length - 1]
        : elements.productForm;

      if (!anchor || !anchor.parentNode) return;

      var trigger = document.createElement('button');
      var label = withFallback(modal.dataset.quoteRequestButtonLabel, labels.button);
      var text = document.createElement('span');

      trigger.className = 'product-form--atc-button product-form--quote-request-button';
      trigger.type = 'button';
      trigger.hidden = true;
      trigger.setAttribute('data-quote-request-trigger', '');

      text.className = 'atc-button--text';
      text.textContent = label;
      trigger.appendChild(text);

      anchor.parentNode.insertBefore(trigger, anchor.nextSibling);
      elements.trigger = trigger;
    }

    function updateTriggerLabel() {
      if (!elements.trigger) return;

      var labelTarget = elements.trigger.querySelector('.atc-button--text') || elements.trigger;
      labelTarget.textContent = withFallback(labelTarget.textContent, labels.button);
    }

    function refreshDynamicElements() {
      elements.trigger = root.querySelector('[data-quote-request-trigger]');
      elements.actionButtons = queryAll(root, '[data-product-atc], .product-form--atc-button:not(.product-form--quote-request-button), gp-product-button');
      elements.paymentButtons = queryAll(root, '.shopify-payment-button');
      elements.paymentTerms = queryAll(root, '[data-payment-terms-reference], [data-payment-terms-target], shopify-payment-terms');
      elements.financingMessages = queryAll(root, '.affirm-as-low-as, .dovr-affirm-messaging');
      elements.pricing = queryAll(root, '[data-product-pricing], gp-product-price');
      elements.quantityControls = queryAll(root, '[data-quantity-selector]');
    }

    ensureTrigger();

    function isJotformConfigured() {
      var requiredFields = [
        'first_name',
        'last_name',
        'email',
        'company',
        'phone',
        'details',
        'product_title',
        'product_url',
        'variant',
        'variant_id',
        'sku',
        'quantity',
        'thumbnail_url',
        'summary'
      ];

      return !!jotformFormId && requiredFields.every(function (field) {
        return !!jotformFields[field];
      });
    }

    function configureJotformSubmission() {
      if (jotformFormId) {
        form.action = 'https://submit.jotform.com/submit/' + jotformFormId;
      } else {
        form.removeAttribute('action');
      }

      setValue(elements.jotformFormId, jotformFormId);
      setValue(elements.jotformSpc, jotformFormId ? jotformFormId + '-' + jotformFormId : '');

      // Jotform generates exact input names, so keep the field map in theme settings.
      setFieldName(elements.firstName, jotformFields.first_name);
      setFieldName(elements.lastName, jotformFields.last_name);
      setFieldName(elements.email, jotformFields.email);
      setFieldName(elements.company, jotformFields.company);
      setFieldName(elements.phone, jotformFields.phone);
      setFieldName(elements.details, jotformFields.details);
      setFieldName(elements.hiddenProduct, jotformFields.product_title);
      setFieldName(elements.hiddenProductUrl, jotformFields.product_url);
      setFieldName(elements.hiddenVariant, jotformFields.variant);
      setFieldName(elements.hiddenVariantId, jotformFields.variant_id);
      setFieldName(elements.hiddenSku, jotformFields.sku);
      setFieldName(elements.hiddenQuantity, jotformFields.quantity);
      setFieldName(elements.hiddenThumbnail, jotformFields.thumbnail_url);
      setFieldName(elements.hiddenMessage, jotformFields.summary);
    }

    function hideMessages() {
      if (elements.successMessage) {
        elements.successMessage.hidden = true;
      }

      if (elements.errorMessage) {
        elements.errorMessage.hidden = true;
        elements.errorMessage.textContent = '';
      }
    }

    function showError(message) {
      if (elements.successMessage) {
        elements.successMessage.hidden = true;
      }

      if (elements.errorMessage) {
        elements.errorMessage.textContent = withFallback(
          message || modal.dataset.quoteRequestSubmitError,
          "We couldn't submit your request. Please try again or contact the store."
        );
        elements.errorMessage.hidden = false;
      }
    }

    function showSuccess() {
      if (elements.errorMessage) {
        elements.errorMessage.hidden = true;
      }

      if (elements.stepsList) {
        elements.stepsList.hidden = true;
      }

      elements.steps.forEach(function (stepElement) {
        stepElement.hidden = true;
        stepElement.classList.remove('quote-request__step--active');
      });

      if (elements.successMessage) {
        elements.successMessage.hidden = false;
        elements.successMessage.focus();
      }
    }

    function setSubmitting(isSubmitting) {
      state.submitting = isSubmitting;

      if (!elements.submitButton) return;

      if (!elements.submitButton.dataset.quoteRequestOriginalText) {
        elements.submitButton.dataset.quoteRequestOriginalText = elements.submitButton.textContent;
      }

      elements.submitButton.disabled = isSubmitting;
      elements.submitButton.textContent = isSubmitting
        ? modal.dataset.quoteRequestSubmittingLabel || elements.submitButton.dataset.quoteRequestOriginalText
        : elements.submitButton.dataset.quoteRequestOriginalText;
    }

    configureJotformSubmission();

    function getCurrentVariant() {
      var currentId = elements.variantInput ? elements.variantInput.value : data.selected_variant_id;
      var gpData = null;

      if (!currentId || currentId === 'not-selected') {
        gpData = parseJsonAttribute(root, 'gp-data') || parseJsonAttribute(root, 'gp-context');

        if (gpData && gpData.variantSelected && gpData.variantSelected.id) {
          currentId = gpData.variantSelected.id;
        }
      }

      if (!currentId || currentId === 'not-selected') {
        return getFallbackQuoteVariant(product);
      }

      return findVariant(product, currentId);
    }

    function getPageQuantity() {
      if (elements.dovrQuantityInput && elements.dovrQuantityInput.value) {
        return normalizeQuantity(elements.dovrQuantityInput.value);
      }

      if (elements.quantityInput && elements.quantityInput.value) {
        return normalizeQuantity(elements.quantityInput.value);
      }

      return 1;
    }

    function getQuantity() {
      return normalizeQuantity(elements.quantity ? elements.quantity.value : getPageQuantity());
    }

    function getVariantImage(variant) {
      if (!variant) return normalizeUrl(data.fallback_image);

      var imageUrl = data.variant_images && data.variant_images[variant.id]
        ? data.variant_images[variant.id]
        : data.fallback_image || '';

      return normalizeUrl(imageUrl);
    }

    function getProductUrl(variant) {
      try {
        var url = new URL(state.productUrl, window.location.origin);

        if (variant) {
          url.searchParams.set('variant', variant.id);
        }

        return url.toString();
      } catch (error) {
        return state.productUrl;
      }
    }

    function updateImage(image, placeholder, url) {
      if (!image || !placeholder) return;

      if (url) {
        image.src = url;
        image.alt = product.title;
        image.hidden = false;
        placeholder.hidden = true;
      } else {
        image.hidden = true;
        placeholder.hidden = false;
      }
    }

    function getSku(variant) {
      return variant && variant.sku ? variant.sku : labels.not_provided;
    }

    function getVariantTitle(variant) {
      return variant && variant.title ? variant.title : labels.none;
    }

    function getName() {
      return [elements.firstName && elements.firstName.value, elements.lastName && elements.lastName.value]
        .filter(Boolean)
        .join(' ')
        .trim();
    }

    function syncHiddenFields() {
      var variant = state.variant;
      var quantity = getQuantity();
      var imageUrl = getVariantImage(variant);

      setValue(elements.hiddenProduct, product.title);
      setValue(elements.hiddenProductUrl, getProductUrl(variant));
      setValue(elements.hiddenVariant, getVariantTitle(variant));
      setValue(elements.hiddenVariantId, variant ? variant.id : '');
      setValue(elements.hiddenSku, variant && variant.sku ? variant.sku : '');
      setValue(elements.hiddenQuantity, quantity);
      setValue(elements.hiddenThumbnail, imageUrl);
    }

    function buildMessage() {
      var company = elements.company && elements.company.value ? elements.company.value : labels.none;
      var phone = elements.phone && elements.phone.value ? elements.phone.value : labels.none;
      var details = elements.details && elements.details.value ? elements.details.value : labels.none;

      return [
        labels.summary_intro,
        '',
        labels.product + ': ' + product.title,
        labels.variant + ': ' + getVariantTitle(state.variant),
        labels.variant_id + ': ' + (state.variant ? state.variant.id : ''),
        labels.sku + ': ' + getSku(state.variant),
        labels.quantity + ': ' + getQuantity(),
        labels.product_url + ': ' + getProductUrl(state.variant),
        labels.thumbnail + ': ' + getVariantImage(state.variant),
        '',
        labels.name + ': ' + getName(),
        labels.email + ': ' + (elements.email ? elements.email.value : ''),
        labels.company + ': ' + company,
        labels.phone + ': ' + phone,
        '',
        labels.details + ':',
        details
      ].join('\n');
    }

    function syncReview() {
      var quantity = getQuantity();
      var company = elements.company && elements.company.value ? elements.company.value : labels.none;
      var phone = elements.phone && elements.phone.value ? elements.phone.value : labels.none;
      var details = elements.details && elements.details.value ? elements.details.value : labels.none;
      var imageUrl = getVariantImage(state.variant);

      setText(elements.reviewProduct, product.title);
      setText(elements.reviewVariant, getVariantTitle(state.variant));
      setText(elements.reviewSku, getSku(state.variant));
      setText(elements.reviewQuantity, quantity);
      setText(elements.reviewName, getName());
      setText(elements.reviewEmail, elements.email ? elements.email.value : '');
      setText(elements.reviewCompany, company);
      setText(elements.reviewPhone, phone);
      setText(elements.reviewDetails, details);
      updateImage(elements.reviewImage, elements.reviewImagePlaceholder, imageUrl);
      syncHiddenFields();
      setValue(elements.hiddenMessage, buildMessage());
    }

    function syncProductInfo(options) {
      var forceQuantityFromPage = options && options.forceQuantityFromPage;
      var variant = options && options.variant ? options.variant : getCurrentVariant();
      var isQuoteVariant = isQuoteRequestVariant(variant);
      var imageUrl = getVariantImage(variant);

      refreshDynamicElements();
      state.variant = variant;
      root.classList.toggle('product--quote-request-active', isQuoteVariant);

      elements.pricing.forEach(function (pricing) {
        pricing.classList.toggle('product-pricing--quote-request', isQuoteVariant);
      });

      if (elements.trigger) {
        updateTriggerLabel();
        setElementHidden(elements.trigger, !isQuoteVariant);
        elements.trigger.disabled = !isQuoteVariant;
      }

      elements.actionButtons.forEach(function (button) {
        setElementHidden(button, isQuoteVariant);
      });

      elements.paymentButtons.forEach(function (button) {
        setElementHidden(button, isQuoteVariant);
      });

      elements.paymentTerms.forEach(function (paymentTerm) {
        setElementHidden(paymentTerm, isQuoteVariant);
      });

      elements.financingMessages.forEach(function (message) {
        setElementHidden(message, isQuoteVariant);
      });

      elements.quantityControls.forEach(function (quantityControl) {
        setElementHidden(quantityControl, isQuoteVariant);
      });

      setText(elements.productTitle, product.title);
      setText(elements.variantTitle, getVariantTitle(variant));
      setText(elements.sku, getSku(variant));
      updateImage(elements.image, elements.imagePlaceholder, imageUrl);

      if (elements.quantity && forceQuantityFromPage) {
        elements.quantity.value = getPageQuantity();
      }

      syncHiddenFields();
      syncReview();
    }

    var syncQueued = false;

    function queueProductInfoSync() {
      if (syncQueued) return;

      syncQueued = true;

      window.setTimeout(function () {
        syncQueued = false;
        syncProductInfo();
      }, 0);
    }

    function setStep(step) {
      state.currentStep = step;

      if (elements.stepsList) {
        elements.stepsList.hidden = false;
      }

      elements.steps.forEach(function (stepElement) {
        var isActive = Number(stepElement.dataset.quoteRequestStep) === step;
        stepElement.hidden = !isActive;
        stepElement.classList.toggle('quote-request__step--active', isActive);
      });

      elements.progress.forEach(function (progressElement) {
        var isActive = Number(progressElement.dataset.quoteRequestProgress) === step;
        progressElement.classList.toggle('quote-request__step-indicator--active', isActive);

        if (isActive) {
          progressElement.setAttribute('aria-current', 'step');
        } else {
          progressElement.removeAttribute('aria-current');
        }
      });
    }

    function validateStep(step) {
      var fields = Array.prototype.slice.call(step.querySelectorAll('input, textarea, select'));

      for (var i = 0; i < fields.length; i += 1) {
        if (!fields[i].checkValidity()) {
          fields[i].reportValidity();
          return false;
        }
      }

      return true;
    }

    function openModal() {
      state.variant = state.variant || getCurrentVariant();

      if (!isQuoteRequestVariant(state.variant)) return;

      state.lastFocus = document.activeElement;
      syncProductInfo({ forceQuantityFromPage: true, variant: state.variant });
      setSubmitting(false);
      hideMessages();
      setStep(1);
      modal.hidden = false;
      document.body.classList.add('quote-request-modal-open');

      if (!isJotformConfigured()) {
        showError(withFallback(
          modal.dataset.quoteRequestConfigError,
          'Quote form is unavailable. Please contact the store for pricing.'
        ));
      }

      window.requestAnimationFrame(function () {
        var focusable = getFocusable(modal);
        (focusable[0] || elements.dialog).focus();
      });
    }

    function closeModal() {
      if (state.submitTimeout) {
        window.clearTimeout(state.submitTimeout);
        state.submitTimeout = null;
      }

      setSubmitting(false);
      modal.hidden = true;
      document.body.classList.remove('quote-request-modal-open');

      if (state.lastFocus && typeof state.lastFocus.focus === 'function') {
        state.lastFocus.focus();
      }
    }

    function handleNext(event) {
      event.preventDefault();

      if (state.currentStep === 1) {
        if (!validateStep(modal.querySelector('[data-quote-request-step="1"]'))) return;
        syncProductInfo({ variant: state.variant });
        setStep(2);
        return;
      }

      if (state.currentStep === 2) {
        if (!validateStep(modal.querySelector('[data-quote-request-step="2"]'))) return;
        syncReview();
        setStep(3);
      }
    }

    function handlePrev(event) {
      event.preventDefault();

      if (state.currentStep > 1) {
        setStep(state.currentStep - 1);
      }
    }

    function handleSubmit(event) {
      var contactStep = modal.querySelector('[data-quote-request-step="2"]');
      var productStep = modal.querySelector('[data-quote-request-step="1"]');

      if (state.currentStep !== 3) {
        event.preventDefault();
        handleNext(event);
        return;
      }

      if (!validateStep(productStep) || !validateStep(contactStep)) {
        event.preventDefault();
        return;
      }

      if (state.submitting) {
        event.preventDefault();
        return;
      }

      syncReview();

      if (!isJotformConfigured()) {
        event.preventDefault();
        showError(withFallback(
          modal.dataset.quoteRequestConfigError,
          'Quote form is unavailable. Please contact the store for pricing.'
        ));
        return;
      }

      hideMessages();
      setSubmitting(true);

      if (state.submitTimeout) {
        window.clearTimeout(state.submitTimeout);
      }

      state.submitTimeout = window.setTimeout(function () {
        if (!state.submitting) return;

        setSubmitting(false);
        showError(modal.dataset.quoteRequestSubmitError);
      }, 30000);
    }

    if (elements.trigger) {
      elements.trigger.addEventListener('click', function (event) {
        event.preventDefault();
        openModal();
      });
    }

    if (elements.productForm) {
      elements.productForm.addEventListener('submit', function (event) {
        var currentVariant = state.variant || getCurrentVariant();

        if (isQuoteRequestVariant(currentVariant)) {
          state.variant = currentVariant;
          event.preventDefault();
          event.stopImmediatePropagation();
          openModal();
        }
      }, true);
    }

    modal.querySelectorAll('[data-quote-request-close]').forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    modal.querySelectorAll('[data-quote-request-next]').forEach(function (button) {
      button.addEventListener('click', handleNext);
    });

    modal.querySelectorAll('[data-quote-request-prev]').forEach(function (button) {
      button.addEventListener('click', handlePrev);
    });

    form.addEventListener('submit', handleSubmit);

    if (elements.iframe) {
      elements.iframe.addEventListener('load', function () {
        if (!state.submitting) return;

        if (state.submitTimeout) {
          window.clearTimeout(state.submitTimeout);
          state.submitTimeout = null;
        }

        setSubmitting(false);
        showSuccess();
      });
    }

    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = getFocusable(modal);
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (elements.variantSelection) {
      elements.variantSelection.addEventListener('variant-change', function (event) {
        syncProductInfo({ variant: event.detail && event.detail.variant });

        window.setTimeout(function () {
          syncProductInfo({ variant: event.detail && event.detail.variant });
        }, 0);

        window.setTimeout(function () {
          syncProductInfo({ variant: event.detail && event.detail.variant });
        }, 150);
      });
    }

    if (elements.variantInput) {
      elements.variantInput.addEventListener('change', function () {
        syncProductInfo();
      });
    }

    root.addEventListener('click', function () {
      window.setTimeout(function () {
        syncProductInfo();
      }, 150);
    });

    root.addEventListener('change', function () {
      window.setTimeout(function () {
        syncProductInfo();
      }, 0);
    });

    if (root.matches && root.matches('gp-product')) {
      var observer = new MutationObserver(function () {
        syncProductInfo();
      });

      observer.observe(root, {
        attributes: true,
        attributeFilter: ['gp-data', 'gp-context']
      });
    }

    var repairObserver = new MutationObserver(function () {
      if (isQuoteRequestVariant(getCurrentVariant())) {
        queueProductInfoSync();
      }
    });

    repairObserver.observe(root, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'disabled', 'hidden', 'style'],
      childList: true,
      subtree: true
    });

    [elements.quantityInput, elements.dovrQuantityInput, elements.quantity].forEach(function (input) {
      if (!input) return;

      input.addEventListener('input', function () {
        syncReview();
      });
      input.addEventListener('change', function () {
        syncReview();
      });
    });

    [
      elements.firstName,
      elements.lastName,
      elements.email,
      elements.company,
      elements.phone,
      elements.details
    ].forEach(function (input) {
      if (!input) return;

      input.addEventListener('input', syncReview);
      input.addEventListener('change', syncReview);
    });

    syncProductInfo({ forceQuantityFromPage: true });

    window.setTimeout(function () {
      syncProductInfo({ forceQuantityFromPage: true });
    }, 150);

    window.setTimeout(function () {
      syncProductInfo({ forceQuantityFromPage: true });
    }, 750);
  }

  function initAll() {
    initGemPagesQuoteGuards(document);
    document.querySelectorAll('[data-quote-request-modal]').forEach(initQuoteRequest);
  }

  var initAllQueued = false;

  function queueInitAll() {
    if (initAllQueued) return;

    initAllQueued = true;

    window.setTimeout(function () {
      initAllQueued = false;
      initAll();
    }, 0);
  }

  function observeInjectedProducts() {
    if (!document.body) return;

    var observer = new MutationObserver(function (mutations) {
      var shouldInit = mutations.some(function (mutation) {
        return Array.prototype.slice.call(mutation.addedNodes).some(function (node) {
          if (!node || node.nodeType !== 1) return false;

          if (node.matches && node.matches('[data-quote-request-modal], [data-quote-request-product], gp-product')) {
            return true;
          }

          return !!(node.querySelector && node.querySelector('[data-quote-request-modal], [data-quote-request-product], gp-product'));
        });
      });

      if (shouldInit) {
        queueInitAll();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  onReady(function () {
    initAll();
    observeInjectedProducts();
  });
  document.addEventListener('shopify:section:load', initAll);
}());
